<form novalidate #form="ngForm">
  <div class="form-row">
    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="category">Power category:</label>
      <select
        id="category"
        class="form-control form-control-sm"
        [value]="category"
        (change)="category = $event.target.value"
      >
        <option value="">All cars</option>
        <option value="1">NA/NB1.6 + NC1.8 + ND1.5 only</option>
        <option value="2">NA/NB1.8 only</option>
        <option value="3">NC/ND2.0 only</option>
        <option value="4">RX-8</option>
        <option value="5">Miata Turbo only</option>
        <option value="10">OPEN class only</option>
      </select>
    </div>

    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="spec">Racing class (SPEC):</label>
      <select
        id="spec"
        class="form-control form-control-sm"
        [value]="spec"
        (change)="spec = $event.target.value"
      >
        <option value="">All racing categories</option>
        <option value="1">SPEC 1 (NA/NB) only</option>
        <option value="2">SPEC 2 (NC) only</option>
        <option value="0">Without SPEC cars</option>
      </select>
    </div>

    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="stock">Car modifications:</label>
      <select
        id="stock"
        class="form-control form-control-sm"
        [value]="stock"
        (change)="stock = $event.target.value"
      >
        <option value="">Not restricted</option>
        <option value="1">Stock cars only</option>
        <option value="0">No stock cars</option>
      </select>
    </div>

    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="women">Driver category:</label>
      <select
        id="women"
        class="form-control form-control-sm"
        [value]="women"
        (change)="women = $event.target.value"
      >
        <option value="">All drivers</option>
        <option value="1">Women only</option>
        <option value="0">Men only</option>
      </select>
    </div>
  </div>

  <div class="form-row">
    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="ranking-laps-number">Ranking laps number:</label>
      <input type="number"
             class="form-control form-control-sm"
             id="ranking-laps-number"
             name="rankingLapsNumber"
             [value]="rankingLapsNumber"
             (change)="rankingLapsNumber = $event.target.value"
      />
    </div>

    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="minimum-lap-seconds">Minimal laptime (s):</label>
      <input type="number"
             class="form-control form-control-sm"
             id="minimum-lap-seconds"
             name="minimumLapSeconds"
             [value]="minimumLapSeconds"
             (change)="minimumLapSeconds = $event.target.value"
      >
    </div>

    <div class="col-3">
      <label class="col-form-label col-form-label-sm" for="maximum-lap-seconds">Maximal laptime (s):</label>
      <input type="number"
             class="form-control form-control-sm"
             id="maximum-lap-seconds"
             name="maximumLapSeconds"
             [value]="maximumLapSeconds"
             (change)="maximumLapSeconds = $event.target.value"
      >
    </div>
  </div>
</form>
